// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ResultCounts__root___KZX8w","value":"ResultCounts__value___SvitU"};